/**
 * Formats config/notes values for single-line display.
 * Prevents React inputs from showing "[object Object]" when the API returns JSON objects.
 */
export const formatJsonValue = (value: unknown): string => {
  if (value == null || value === '') {
    return '';
  }

  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (trimmed.startsWith('{') || trimmed.startsWith('[')) {
      try {
        return JSON.stringify(JSON.parse(trimmed));
      } catch {
        return value;
      }
    }
    return value;
  }

  if (typeof value === 'boolean') {
    return value ? 'true' : 'false';
  }

  if (typeof value === 'number') {
    return String(value);
  }

  if (typeof value === 'object') {
    try {
      return JSON.stringify(value);
    } catch {
      return String(value);
    }
  }

  return String(value);
};

/** Parses edited text back to object/array when the user enters valid JSON. */
export const parseJsonValueInput = (input: string): unknown => {
  const trimmed = input.trim();
  if (!trimmed) {
    return '';
  }

  if (trimmed.startsWith('{') || trimmed.startsWith('[')) {
    try {
      return JSON.parse(trimmed);
    } catch {
      return input;
    }
  }

  return input;
};
